import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import { getFormTitle } from '.';

const DownloadFormModal = ({ show, selectedForm, handleDownload, handleCancel }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show}>
      <ModalHeading heading={t('screens.websiteForms.downloadTitle', { form: getFormTitle(selectedForm.type, selectedForm.agent, t) })} />
      <ModalForm style={{ marginBottom: '2.5rem' }}>
        <InputsSection style={{ width: '34rem' }}>
          <p className='primaryText'>{t('screens.websiteForms.downloadNote')}</p>
        </InputsSection>

        <ModalButtons submitButtonLabel={t('screens.websiteForms.downloadBtn')} onSubmit={handleDownload} cancelButtonLabel={t('screens.websiteForms.cancel')} onCancel={handleCancel} />
      </ModalForm>
    </Modal>
  );
};

export default DownloadFormModal;
